import d from "./_assocIndexOf.js";
var n = d;
function r(t) {
  var a = this.__data__, e = n(a, t);
  return e < 0 ? void 0 : a[e][1];
}
var i = r;
export {
  i as default
};
//# sourceMappingURL=_listCacheGet.js.map
